import TokenIcon from '@passkeys/ui/token-icon';

import type { Asset } from '@/types';
import Image from '@/ui/components/image';
import type { Nft } from '@/ui/types';

type HeroProps = {
  asset?: Asset;
  collectible?: Nft;
};

function Hero({ asset, collectible }: HeroProps) {
  return (
    <>
      {asset && (
        <TokenIcon
          name={asset.name}
          displayName={asset.displayName}
          size={80}
          className="mb-8 mt-2"
        />
      )}

      {collectible && (
        <Image
          src={collectible.image}
          className="mt-4 w-[150px] rounded-[32px] shadow-xl"
        />
      )}
    </>
  );
}

export default Hero;
